import React from 'react';
import PropTypes from 'prop-types';
import UserAvatar from '../../../assets/images/user.png';

function ReviewCard({
  resourceId, projectResourceId, name, projectName, reviewed, rate,
}) {
  return (
    <div className="card box-shadow-1">
      <div className="project-detail">
        <div className="reviews-card">
          <div className="avatar">
            <img src={UserAvatar} alt="" />
          </div>
          <div className="details">
            <p>{name}</p>
            <div className="tags">
              <span className="badge small normal-font mr-5">
                $
                {rate}
                /hr
              </span>
            </div>
          </div>
          <div className="action">
            <a
              id="review-single-alert"
              href={reviewed ? `/projects/${projectResourceId}/reviews/${resourceId}` : `/projects/${projectResourceId}/reviews/new`}
              className="btn btn-primary"
              role="button"
            >
              Review
            </a>
          </div>
        </div>
        <hr />
        <p className="user-description">
          {projectName}
        </p>
      </div>
    </div>
  );
}

ReviewCard.propTypes = {
  name: PropTypes.string.isRequired,
  rate: PropTypes.number.isRequired,
  reviewed: PropTypes.bool.isRequired,
  projectName: PropTypes.string.isRequired,
  projectResourceId: PropTypes.string.isRequired,
  resourceId: PropTypes.string,
};

ReviewCard.defaultProps = {
  resourceId: '',
};

export default ReviewCard;
